import React from "react";

const IconSpinner = () => {
    return (
        <div>
            <i className="spinner spinnerPrimary" />
        </div>
    );
};

export default IconSpinner;
